<template>
  <router-view :style="this.$store.getters.style"></router-view>
</template>

<script>

export default {
  name: 'App',
  mounted() {
    this.$i18n.locale = this.$route.params.lang
    console.log(this.$store.state.current_lang)
    this.$vuetify.rtl = this.$i18n.locale === "fa" || this.$i18n.locale === "ar"
    if (this.$i18n.locale === 'fa' || this.$i18n.locale === 'ar') {
      this.$store.dispatch('setFont', 'font-family:IRANSans,serif')
    } else {
      this.$store.dispatch('setFont', 'font-family:Roboto,sans-serif')
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        document.title = to.meta.title || 'Madrese International Film Festival';
      }
    },
  }
};
</script>
<style>
.v-application--is-rtl .v-btn {
  letter-spacing: 0 !important;
}
</style>
